class TrackingForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.orderTemplate = this.querySelector("template.order-card-template");
    this.ordersContainer = this.querySelector(".orders");
  }

  handleSubmit(event) {
    event.preventDefault();
    const phoneNum = this.form.querySelector('input[name="phone_num"]').value;
    if (!phoneNum.trim()) return;

    const submitBtn = this.form.querySelector('[type="submit"]');
    submitBtn.classList.add("loading");

    fetch(
      `https://smilegrows.vercel.app/api/proxy/order-tracking?phoneNum=${encodeURIComponent(phoneNum)}&shop=${
        window.shopDomain
      }`
    )
      .then((response) => response.json())
      .then((data) => {
        const orders = Object.values(data);

        if (orders.length === 0) {
          this.ordersContainer.classList.remove("hidden");
          return;
        }

        orders.forEach((order) => {
          console.log(order.id);
          const clone = this.orderTemplate.content.cloneNode(true);

          const quantities = order.products.reduce(
            (acc, curr) => ({
              products: acc.products + 1,
              items: +acc.items + +curr.quantity,
            }),
            {
              products: 0,
              items: 0,
            }
          );

          clone.querySelector(".order-card").setAttribute("data-status", order.statusCode.toLowerCase());
          clone.querySelector("[data-attribute='id']").textContent = order.id;
          clone.querySelector("[data-attribute='price']").textContent =
            Number(order.calcTotalMoney).toLocaleString("vi-VN") + "đ";
          clone.querySelector("[data-attribute='status']").textContent = order.statusName;
          clone.querySelector("[data-attribute='products']").textContent = `${quantities.products} sản phẩm`;
          clone.querySelector("[data-attribute='items']").textContent = `${quantities.items} món hàng`;
          clone.querySelector("[data-attribute='customer']").textContent = order.customerName;
          clone.querySelector("[data-attribute='created-at']").textContent = order.createdDateTime;

          // Append to DOM
          this.ordersContainer.appendChild(clone);
        });
      })
      .catch((error) => {
        console.error("Error fetching order status:", error);
        this.ordersContainer.innerHTML = "<p>Error fetching order status.</p>";
      })
      .finally(() => {
        submitBtn.classList.remove("loading");
      });
  }
}

customElements.define("tracking-form", TrackingForm);
